(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderDialogController', EnvOrderDialogController);

    EnvOrderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EnvOrder', 'EnvTest', 'Machine'];

    function EnvOrderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EnvOrder, EnvTest, Machine) {
        var vm = this;

        vm.envOrder = entity;
        vm.clear = clear;
        vm.save = save;
        vm.envtests = EnvTest.query();
        vm.machines = Machine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.envOrder.id !== null) {
                EnvOrder.update(vm.envOrder, onSaveSuccess, onSaveError);
            } else {
                EnvOrder.save(vm.envOrder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:envOrderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
